import { render } from "./Gallery_1.vue?vue&type=template&id=78e8b2f1&ts=true"
import script from "./Gallery_1.vue?vue&type=script&lang=ts"
export * from "./Gallery_1.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__